import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import Button from '../../Button'
import { Container } from '../Container'

function Tooltips() {
  return (
    <>
      <Container label='Tooltip, top placement'>
        <Button.Contained
          text='Contained'
          tooltip='Tooltip'
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
        />
      </Container>
      <Container label='Tooltip, bottom placement'>
        <Button.Contained
          text='Contained'
          tooltip='Tooltip'
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.bottom}
        />
      </Container>
      <Container label='Tooltip, left placement'>
        <Button.Contained
          text='Contained'
          tooltip='Tooltip'
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.left}
        />
      </Container>
      <Container label='Tooltip, right placement'>
        <Button.Contained
          text='Contained'
          tooltip='Tooltip'
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.right}
        />
      </Container>
    </>
  )
}

export default Tooltips
